const contentFooter = () => import('@/pages/content/footer/index.vue');

export default [{
    path: '/content/footer',
    component: contentFooter,
    meta: [{
        name: '内容管理',
		activeRoute: '/content/manage'
    },
    {
        name: '底部导航栏',
        activeRoute: '/content/footer'
    }]
}];